"use client";

import { ExternalLink } from "lucide-react";
import { HOWARD_COUNTY_LINKS } from "@/components/tenant/howard-county/howard-county-config";
import { useT } from "@/features/i18n/hooks/use-t";
import { tilliPrivacySections } from "./tilli-privacy-data";

export default function PrivacyContent() {
  const { t } = useT();

  return (
    <div className="w-full space-y-10 pb-10 sm:pb-0">
      <section>
        <h2 className="mb-4 font-semibold text-lg">
          {t("privacy.tilliXTitle")}
        </h2>
        <p className="mb-2 text-muted-foreground text-sm">
          {t("privacy.lastModified")}
        </p>
        <div className="space-y-6">
          {tilliPrivacySections.map((section) => (
            <div id={section.id} key={section.id}>
              <h3 className="mb-2 font-medium text-base">
                {t(section.titleKey)}
              </h3>
              {section.paragraphKeys.map((key) => (
                <p
                  className="mb-2 text-muted-foreground leading-relaxed"
                  key={key}
                >
                  {t(key)}
                </p>
              ))}
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="mb-4 font-semibold text-lg">
          {t("privacy.howardCountyTitle")}
        </h2>
        <p className="text-muted-foreground leading-relaxed">
          {t("privacy.comingSoon")}
        </p>
      </section>

      <section>
        <h2 className="mb-4 font-semibold text-lg">
          {t("privacy.howardCountyStatement")}
        </h2>
        <a
          className="inline-flex items-center gap-1.5 text-primary text-sm hover:underline"
          href={HOWARD_COUNTY_LINKS.privacyStatement}
          rel="noopener noreferrer"
          target="_blank"
        >
          <ExternalLink className="h-3.5 w-3.5" />
          {t("privacy.howardCountyLinkText")}
        </a>
      </section>
    </div>
  );
}
